import { useState } from 'react';

import { getInitialPage, PAGE_SIZE } from './utils';

import type { AnnouncementListEntry } from './types';

interface AnnouncementPagination {
  /** 지정한 페이지로 이동합니다. */
  goToPage: (page: number) => void;
  /** 현재 페이지 (0-based) */
  page: number;
  /** 현재 페이지에 표시할 새소식 목록 (최대 PAGE_SIZE 개) */
  pageAnnouncements: AnnouncementListEntry[];
}

/**
 * 목록의 페이지 상태를 list 컴포넌트 내부에 가둡니다.
 * @description
 * - 페이지 이동이 상위 모달·본문 영역을 리렌더하지 않도록 page 상태를 이 훅이 소유합니다.
 * - 초기 페이지는 선택된 글이 포함된 페이지로 시작합니다.
 * - 이전/다음 버튼의 비활성 처리는 CompactPagination 이 page·count·rowsPerPage 로 계산합니다.
 */
const useAnnouncementPagination = (
  announcements: AnnouncementListEntry[],
  initialAnnouncementId: string,
): AnnouncementPagination => {
  const [page, setPage] = useState(() =>
    getInitialPage(announcements, initialAnnouncementId, PAGE_SIZE),
  );

  return {
    page,
    pageAnnouncements: announcements.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE),
    goToPage: setPage,
  };
};

export default useAnnouncementPagination;
